var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/viewmodels/networkmembers',["require", "exports", "models/breeze", "common/constants", "services/navigator", "services/settings", "areas/organizationmanager/commands/downloadmemberpdfcommand", "areas/organizationmanager/commands/directloginmembercommand", "areas/organizationmanager/commands/showuserdatacommand", "areas/organizationmanager/models/organizationbase", "areas/organizationmanager/services/networkmemberrepository", "areas/organizationmanager/services/mappings"], function (require, exports, Data, constants, navigator, configuration, DownloadMemberPdfCommand, DirectLoginMemberCommand, ShowUserDataCommand, organization, repository, mappings) {
    "use strict";
    var NetworkMembersViewModell = (function (_super) {
        __extends(NetworkMembersViewModell, _super);
        //#region ctor
        function NetworkMembersViewModell() {
            _super.call(this);
            this.networkMembers = new repository.NetworkMemberRepository();
            this.userData = "";
            this.possibleUserTypes = new Array(); //possible usertypes for filter
            this.selectedUserTypes = new Array(); //usertypes which selected for the filter
            this.originalResult = ko.observableArray(); //the results from the server
            ko.track(this, ['organizationURL', 'selectedUserTypes', 'userData', 'searchLogin']);
        }
        //#endregion
        //#region overrides
        NetworkMembersViewModell.prototype.onActivated = function (context) {
            _super.prototype.onActivated.call(this, context);
            this.initialize(context);
        };
        //#endregion
        //#region navigation
        NetworkMembersViewModell.prototype.goBack = function () {
            navigator.goBack();
        };
        //#endregion
        NetworkMembersViewModell.prototype.getDisplayNameForMemberType = function (memberType) {
            return constants.NetworkMemberTypes.getDisplayNameForGivenMemberType(memberType);
        };
        //#region filters
        NetworkMembersViewModell.prototype.memberSearch = function () {
            var _this = this;
            var filters = [];
            filters.push(Data.BreezeColumnFilter.contains("LoginName", this.searchLogin));
            this.controller.filterDefinitions.modify(function (s) {
                s.remove("LoginName");
                s.attach(filters);
            });
            this.resultSupscription = this.controller.result.subscribe(function () {
                if (_this.controller.result().length > 0) {
                    _this.resultSupscription.dispose();
                    _this.originalResult.removeAll();
                    for (var i = 0; i < _this.controller.result().length; i++) {
                        _this.originalResult.push(_this.controller.result()[i]);
                    }
                }
            });
            this.controller.load();
        };
        NetworkMembersViewModell.prototype.filterUserTypes = function () {
            var _this = this;
            this.userData = "";
            this.selectedItems.removeAll();
            this.controller.result.removeAll();
            for (var j = 0; j < this.originalResult().length; j++) {
                this.controller.result.push(this.originalResult()[j]);
            }
            this.controller.itemsCount(this.originalResult().length);
            for (var i = this.controller.result().length - 1; i >= 0; i--) {
                if (this.selectedUserTypes.filter(function (s) { return s == _this.controller.result()[i].memberType; }).length == 0) {
                    this.controller.result.remove(this.controller.result()[i]);
                    this.controller.itemsCount(this.controller.itemsCount() - 1);
                }
            }
        };
        //#endregion
        //#region helpers
        NetworkMembersViewModell.prototype.initialize = function (context) {
            var host = configuration.Settings.getHost();
            this.organizationUri = context.queryString.organizationUri;
            this.organizationUrl = host.substring(0, host.indexOf(":") + 1) + "//" + this.organizationUri.split("\\")[0] + host.substring(host.indexOf("."));
            this.organizationId = context.queryString.organizationId;
            this.organizationTyp = context.queryString.organizationTyp;
            this.organizationAccessNumber = this.organizationUri.split("\\").length > 1 ? this.organizationUri.split("\\")[1] : null;
            this.searchLogin = "";
            this.userData = "";
            this.setPossibleOrganizationTypes();
            this.setUpController();
            this.applyHandlers();
            //commands
            this.downloadMemberPdfCommand = new DownloadMemberPdfCommand();
            this.directLoginMemberCommand = new DirectLoginMemberCommand();
            this.showUserDataCommand = new ShowUserDataCommand(this.organizationUri, this.organizationUrl);
        };
        NetworkMembersViewModell.prototype.setUpController = function () {
            var _this = this;
            var params = { organizationId: this.organizationId };
            this.controller = new Data.BreezeDataController(this.networkMembers).configure(function (result) { return result.map(function (s) { return mappings.Mapper.mapNetworkMemberItemFromDTO(s); }); });
            this.controller.sortDefinitions.modify(function (s) { return s.add(_this.controller.buildSort("LoginName", "asc")); });
            this.controller.override("byorganization", params);
        };
        NetworkMembersViewModell.prototype.applyHandlers = function () {
            var _this = this;
            ko.getObservable(this, "selectedUserTypes").subscribe(function () {
                _this.filterUserTypes();
            });
            this.resultSupscription = this.controller.result.subscribe(function () {
                if (_this.controller.result().length > 0) {
                    _this.resultSupscription.dispose();
                    _this.originalResult.removeAll();
                    for (var i = 0; i < _this.controller.result().length; i++) {
                        _this.originalResult.push(_this.controller.result()[i]);
                    }
                }
            });
            this.selectedItems.subscribe(function () {
                _this.userData = "";
            });
        };
        NetworkMembersViewModell.prototype.setPossibleOrganizationTypes = function () {
            if (this.organizationTyp.toLowerCase() == constants.OrganizationTypes.Stb.toLowerCase()) {
                this.possibleUserTypes.push(constants.NetworkMemberTypes.StbAdmin);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.StbEmployee);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.StbGateway);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.StbPostmaster);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.StbServiceLogin);
            }
            else if (this.organizationTyp.toLowerCase() == constants.OrganizationTypes.Client.toLowerCase()) {
                this.possibleUserTypes.push(constants.NetworkMemberTypes.ClientAdmin);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.ClientEmployee);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.ClientPostmaster);
                this.possibleUserTypes.push(constants.NetworkMemberTypes.ClientClerk);
            }
            for (var i = 0; i < this.possibleUserTypes.length; i++) {
                this.selectedUserTypes.push(this.possibleUserTypes[i]);
            }
        };
        return NetworkMembersViewModell;
    }(organization.OrganizationBase));
    return NetworkMembersViewModell;
});

